import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'mdk-app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {
    @Input() title:string = "MDK Application";
    @ViewChild('accordion')
    accordion!: ElementRef<HTMLElement>;

    ngAfterViewInit() {
        window.vl.accordion.dress(this.accordion.nativeElement);
    }
}